import { Component, Input, OnInit } from '@angular/core';
import { RentalsUnitedService } from '../..';
import { first } from 'rxjs/operators';
import { AuthenticationService, UserService } from '@app/_services';
import { PropertyService } from '@app/_components/property';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ReportService } from '@app/_components/report';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ApiResponse } from '@app/_models';
import { DialogService } from 'primeng/dynamicdialog';
import { RuReservationDetailComponent } from './components/ru-reservation-detail/ru-reservation-detail.component';


@Component({
    selector: 'app-ru-reservation',
    templateUrl: './ru-reservation.component.html',
    styleUrls: ['./ru-reservation.component.css'],
    providers: [DialogService],
    standalone: false
})
export class RuReservationComponent implements OnInit {

	selectedShortTermRental: any;
	ruReservations: any = [];
	shortTermRentals: any = [];

	// data
	apiResponse: ApiResponse;

	@Input() ruAccount: any;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;
	formErrorMessage: String;

	validationMessages = {
		shortTermRentalId: [{ type: 'required', message: 'Property is required' }],
		startDate: [],
		endDate: []
	};

	constructor(
		private rentalsUnitedService: RentalsUnitedService,
		private authenticationService: AuthenticationService,
		private userService: UserService,
		private propertyService: PropertyService,
		private router: Router,
		private messageService: MessageService,
		private route: ActivatedRoute,
		private reportService: ReportService,
		private activatedRoute: ActivatedRoute,
		private formBuilder: UntypedFormBuilder,
		public dialogService: DialogService) { }



	ngOnInit(): void {
		this.buildForm();
		this.loadShortTermRentals();
	}

	onFormSubmit() {
		if (this.form1.invalid) {
			return;
		}
		this.pushRuReservation(this.form1.value);
	}

	onListReservations() {
		if (this.form1.invalid) {
			return;
		}
		this.loadRuReservation(this.form1.value);
	}

	onSyncAllReservations() {
		let ruRequest = { startDate: '', endDate: '' };
		this.syncAllReservations(ruRequest);
	}


	onShowRuReservationJsonClick(reservation) {
		const ref = this.dialogService.open(RuReservationDetailComponent, {
			data: {
				reservation: reservation
			},
			header: 'Reservation Detail',
			width: '90%'
		});
	}

	syncAllReservations(ruRequest) {
		this.formLoading = true;
		this.rentalsUnitedService.syncAllReservations(ruRequest)
			.pipe(first())
			.subscribe(
				res => {
					this.messageService.add({ severity: 'success', summary: 'Sync All Reservations', detail: '' + res.message, sticky: false });
				},
				err => {
					console.log('error In syncAllReservations is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'syncAllReservations Failed', detail: 'We were unable to sync RuProperties: ' + err, sticky: false });
				},
				() => { this.formLoading = false; });
	}

	loadRuReservation(form1) {
		this.formLoading = true;
		this.rentalsUnitedService.listReservations(form1)
			.pipe(first())
			.subscribe(
				res => {
					console.log('loadRuReservation: ' + JSON.stringify(res));
					this.ruReservations = res.data.reservations;
				},
				err => {
					console.log('error In loadRuReservation is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'loadRuReservation Failed', detail: 'We were unable to retrieve your RuProperties: ' + err, sticky: false });
				},
				() => { this.formLoading = false; });
	}


	pushRuReservation(form1) {
		this.formLoading = true;
		this.rentalsUnitedService.pushReservations(form1)
			.pipe(first())
			.subscribe(
				res => {
					console.log('pushRuReservation: ' + JSON.stringify(res));
					this.messageService.add({ severity: 'success', summary: 'Push Reservation', detail: '' + res.message, life: 3000 });
					this.loadRuReservation(this.form1.value);
				},
				err => {
					console.log('error In login.component is: ' + JSON.stringify(err));
					this.formLoading = false;
					this.messageService.add({ severity: 'error', summary: 'pushRuReservation Failed', detail: 'We were unable to push the reservation: ' + err, life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList()
			.subscribe(
				res => {
					// console.log('loadShortTermRentals SUCCESS: ' + JSON.stringify(res.data.propertySummaryList));
					this.shortTermRentals = res.data.propertySummaryList;
					this.shortTermRentals.unshift({});
				},
				err => {
					console.log('loadShortTermRentals FAIL: ' + JSON.stringify(err));
					this.messageService.add({ severity: 'error', summary: 'loadShortTermRentals Failed', detail: 'We were unable to retrieve your shortTermRentals: ' + err, life: 3000 });
				},
				() => { this.formLoading = false; });
	}

	buildForm() {
		this.form1 = this.formBuilder.group({
			shortTermRentalId: [''],
			startDate: [''],
			endDate: [''],
			ruAccount: [this.ruAccount],
		});
	}
}
